module.exports = __webpack_public_path__ + "static/media/Genie-Espinosa-Illustration.3fdf318d.jpg";